const HighlightingDisabledClassName = "highlighting-disabled";

export const disableHighlightingOnBody = () => {
	document.body.classList.add(HighlightingDisabledClassName);
};

export const enableHighlightingOnBody = () => {
	document.body.classList.remove(HighlightingDisabledClassName);
};
